import { createSignal, createEffect, onCleanup, type Accessor } from "solid-js";

export function useDebounced<T>(source: Accessor<T>, delay = 200): Accessor<T> {
  const [debounced, setDebounced] = createSignal<T>(source());

  createEffect(() => {
    const v = source();
    const handle = setTimeout(() => setDebounced(() => v), delay);
    onCleanup(() => clearTimeout(handle));
  });

  return debounced;
}
